/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '../core/request';

export class Service {
  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async optionsService(): Promise<any> {
    const result = await __request({
      method: 'OPTIONS',
      path: `*`,
    });
    return result.body;
  }
}
